// utils/compressImage.js
import imageCompression from 'browser-image-compression';

/**
 * Compress an image file to ensure it's under the specified max size (default: 1MB).
 * 
 * @param {File} file - The original image file to compress.
 * @param {number} maxSizeMB - Max size in MB after compression (default: 1).
 * @param {number} maxWidthOrHeight - Optional resizing dimensions (default: 1920).
 * @returns {Promise<File>} - A compressed File object.
 * @throws Will throw if compression fails or cannot meet size constraint.
 */
export const compressImage = async (
  file,
  maxSizeMB = 0.5,
  maxWidthOrHeight = 1920
) => {
  if (!file || !file.type.startsWith('image/')) {
    throw new Error('Only image files can be compressed.');
  }

  try {
    const options = {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker: true,

    };

    const compressedFile = await imageCompression(file, options);
    console.log(compressedFile, "compressed")
    // Ensure the file is actually under the limit
    if (compressedFile.size > maxSizeMB * 1024 * 1024) {
      throw new Error(`Compressed file still exceeds ${maxSizeMB}MB.`);
    }

    return compressedFile;
  } catch (error) {
    console.error('Compression failed:', error);
    throw new Error(`Compression failed for ${file.name}`);
  }
};
